import * as React from "react";
import { cn } from "../util";

/* Tarjeta sin radio: hairline, fondo cream, sin sombra. */
export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("border border-linea bg-card text-card-foreground", className)} {...props} />
  );
}
export function CardEncabezado({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-col gap-1 p-5 pb-3", className)} {...props} />;
}
export function CardTitulo({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn("font-titulo text-lg font-bold leading-tight", className)} {...props} />;
}
export function CardDescripcion({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("font-ui text-sm text-tinta-tenue", className)} {...props} />;
}
export function CardContenido({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-5 pt-0", className)} {...props} />;
}
export function CardPie({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("flex items-center border-t border-linea p-5 pt-3", className)} {...props} />
  );
}
